import React from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../lib/utils';
import { LITHUB_SHELF_PATH, LITARCHIVE_PATH } from '../../config/featureNav';
import { BookOpen, Archive } from 'lucide-react';

interface LitHubViewTabsProps {
  active: 'shelf' | 'archive';
  className?: string;
}

export const LitHubViewTabs: React.FC<LitHubViewTabsProps> = ({ active, className }) => {
  const navigate = useNavigate();

  const tabs = [
    { id: 'shelf' as const, label: 'Shelf', path: LITHUB_SHELF_PATH, icon: BookOpen },
    { id: 'archive' as const, label: 'LitArchive', path: LITARCHIVE_PATH, icon: Archive },
  ];

  return (
    <div
      className={cn('flex gap-1 p-1 bg-slate-100 rounded-xl w-fit', className)}
      data-testid="lithub-view-tabs"
      role="tablist"
    >
      {tabs.map(({ id, label, path, icon: Icon }) => (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={active === id}
          onClick={() => navigate(path)}
          className={cn(
            'flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition-all',
            active === id
              ? 'bg-white text-emerald-700 shadow-sm'
              : 'text-slate-600 hover:text-slate-800 hover:bg-white/60'
          )}
          data-testid={`lithub-tab-${id}`}
        >
          <Icon className="w-4 h-4" />
          {label}
        </button>
      ))}
    </div>
  );
};

export default LitHubViewTabs;
